import heroBg from '../../assets/course/samurai-hero.jpg';
import instructorImg from '../../assets/team/tanvirul_islam.jpg';

export const COURSE_CONTACT = {
  email: 'arvixcreative@gmail.com',
  whatsapp: '8801645076455',
  whatsappDisplay: '01645-076455',
};

export const generateCourseSlug = (title) =>
  title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

export const STATIC_COURSES = [
  {
    id: 'creative-samurai',
    title: 'Creative Samurai Volume 1',
    heroTitle: 'Creative Samurai',
    subtitle: 'Volume 1',
    tagline: 'Graphic Design · Beginner to Professional',
    description:
      'From zero to freelance-ready in 8 weeks. Master Adobe Illustrator & Photoshop, build a killer portfolio, and start earning. 32 hands-on classes, real projects, real results.',
    duration: '2 Months · 32 Classes',
    level: 'Beginner to Professional',
    fee: '৳ 4,400',
    originalFee: '৳ 5,500',
    discountPercent: 20,
    eyebrow: 'Arvix Creative · Professional Course · 2026',
    heroImage: heroBg,
    pills: ['2 Months', '32 Classes', '4 Days / Week', 'Beginner to Pro'],
    stats: [
      { num: '8', label: 'Weeks' },
      { num: '32', label: 'Classes' },
      { num: '2', label: 'Softwares' },
      { num: '6+', label: 'Projects' },
      { num: '৳4,400', label: 'Course Fee' },
    ],
    software: [
      {
        icon: 'Ai',
        name: 'Adobe Illustrator',
        description:
          'Vector graphics, logo design, icon creation, typography, branding, and business stationery, the core toolkit of every professional designer.',
      },
      {
        icon: 'Ps',
        name: 'Adobe Photoshop',
        description:
          'Photo editing, retouching, poster design, social media visuals, layer masks, blend modes, and background removal, where ideas become images.',
      },
    ],
    months: [
      {
        label: 'Month 1 · Weeks 1 to 4',
        title: 'Adobe Illustrator & Logo Design',
        weeks: [
          {
            title: 'Week 1: Design Fundamentals',
            items: [
              'Introduction to graphic design & career opportunities',
              'Design principles, color theory & typography',
              'Branding basics & Illustrator interface',
              'Shape tools, selection tools & basic object creation',
            ],
          },
          {
            title: 'Week 2: Vector Design',
            items: [
              'Pen tool fundamentals',
              'Pathfinder & Shape Builder tools',
              'Strokes, fills & gradients',
              'Vector tracing & icon design',
            ],
            project: '5-Icon Set',
          },
          {
            title: 'Week 3: Logo Design Mastery',
            items: [
              'Logo design principles',
              'Logo research & sketching',
              'Building logos in Illustrator',
              'Logo presentation techniques',
            ],
            project: 'Pro Logo',
          },
          {
            title: 'Week 4: Branding & Identity',
            items: [
              'Typography in branding',
              'Custom lettermark logo design',
              'Brand identity design',
              'Business card & stationery',
            ],
            project: 'Mini Brand Package',
          },
        ],
      },
      {
        label: 'Month 2 · Weeks 5 to 8',
        title: 'Adobe Photoshop & Pro Design',
        weeks: [
          {
            title: 'Week 5: Photoshop Fundamentals',
            items: [
              'Photoshop interface & layer management',
              'Selection & transform tools',
              'Image retouching basics',
              'Smart objects & export settings',
            ],
            project: 'Social Media Post',
          },
          {
            title: 'Week 6: Advanced Photoshop',
            items: [
              'Layer masks & clipping masks',
              'Adjustment layers & color correction',
              'Blend modes & effects',
              'Background removal',
            ],
            project: 'Promotional Poster',
          },
          {
            title: 'Week 7: Social Media & Advertising',
            items: [
              'Social media post design',
              'Banner & product advertisement design',
              'Thumbnail & cover design',
              'Social media campaign project',
            ],
            project: 'Full Social Media Campaign',
          },
          {
            title: 'Week 8: Portfolio & Freelancing',
            items: [
              'Portfolio development & Behance setup',
              'Freelancing on Fiverr & Upwork',
              'Client communication & pricing strategy',
              'Final portfolio review & career roadmap',
            ],
            project: 'Complete Brand Identity',
          },
        ],
      },
    ],
    projects: [
      {
        num: '01',
        tag: 'Week 2 · Illustrator',
        name: 'Icon Set Design',
        desc: 'Design 5 professional icons using vector tools, pathfinder, and advanced pen techniques.',
      },
      {
        num: '02',
        tag: 'Week 3 · Branding',
        name: 'Professional Logo',
        desc: 'Research, sketch, and execute a complete logo from concept to final delivery file.',
      },
      {
        num: '03',
        tag: 'Week 4 · Identity',
        name: 'Brand Identity Package',
        desc: 'Typography, business cards and stationery, your first mini brand identity system.',
      },
      {
        num: '04',
        tag: 'Week 5 · Photoshop',
        name: 'Social Media Post',
        desc: 'Design a polished social post using layers, smart objects and proper export settings.',
      },
      {
        num: '05',
        tag: 'Week 6 · Photoshop',
        name: 'Promotional Poster',
        desc: 'A cinematic promotional poster using masks, blend modes and advanced color grading.',
      },
      {
        num: '06',
        tag: 'Final · Full Stack',
        name: 'Complete Brand Identity',
        desc: 'Logo, business card, letterhead, social post, poster and brand mockup, your graduation project.',
      },
    ],
    outcomes: [
      'Create professional logos and brand identities that win clients',
      'Design scroll-stopping social media and marketing materials',
      'Use Adobe Illustrator and Photoshop with full confidence',
      'Build a strong, industry-ready portfolio on Behance',
      'Start freelancing and attract clients on Fiverr & Upwork',
      'Present design projects like an industry-level designer',
    ],
    bonus: [
      'Canva for Designers: fast-track client work',
      'Adobe Firefly & AI Tools: stay ahead of the curve',
      'Design Presentation Skills: pitch and win projects',
      'Real Client Project Workflow: handle actual briefs',
    ],
    instructor: {
      name: 'Tanvirul Islam',
      title: 'Founder, CEO & Graphic Designer',
      badge: 'Founder · Arvix Creative',
      image: instructorImg,
      bio: 'Tanvirul Islam is a professional graphic designer, Creative Visualizer, and the founder of Arvix Creative. With 5 years of hands-on experience, he has built brand identities, social media design systems, and digital visuals for clients across industries. He currently works as a Designer at July Mass Uprising Memorial Museum. His mission: Visuals that go beyond imagination.',
      employer: 'July Mass Uprising Memorial Museum',
      stats: [
        { num: '5+', label: 'Years Experience' },
        { num: '200+', label: 'Projects Delivered' },
        { num: '3+', label: 'Industries Served' },
      ],
      tags: [
        'Brand Identity',
        'Logo Design',
        'Social Media Design',
        'Digital Visuals',
        'Adobe Illustrator',
        'Adobe Photoshop',
      ],
    },
    topics: [
      'Adobe Illustrator: Vector, Logo & Icon Design',
      'Adobe Photoshop: Retouching & Poster Design',
      'Brand Identity & Business Stationery',
      'Social Media & Advertising Design',
      'Portfolio Building on Behance',
      'Freelancing on Fiverr & Upwork',
      'Bonus: Canva, Adobe Firefly & AI Tools',
      'Real Client Project Workflow',
    ],
    isStatic: true,
  },
];

export const getStaticCourseBySlug = (courseSlug) =>
  STATIC_COURSES.find((course) => course.id === courseSlug || course.slug === courseSlug) ?? null;

/** @deprecated use getStaticCourseBySlug */
export const getStaticCourseById = getStaticCourseBySlug;

export const getCoursePath = (course) => {
  const slug = course.slug || course.id || generateCourseSlug(course.title);
  return `/courses/${slug}`;
};

export const isNumericCourseId = (courseId) => /^\d+$/.test(courseId);

export const isStaticCourseId = (courseId) =>
  STATIC_COURSES.some((course) => course.id === courseId);

/** API courses minus those already shown as a static landing (e.g. Creative Samurai). */
export const withoutStaticDuplicates = (courses = []) =>
  courses.filter((course) => !STATIC_COURSES.some((s) => s.id === course.slug || s.slug === course.slug));
